import React, { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'

import { InfoCardProps } from './props'
import { Container, Title, Value, SubValue, DataCollectedLabel } from './styles'

export const InfoCard: FunctionComponent<InfoCardProps> = ({
  title,
  value,
  subTitle,
  subValue,
  isDataLabel,
}) => {
  const { t } = useTranslation()

  return (
    <Container>
      <Title>{title}</Title>
      <Value>{value}</Value>
      {!!subTitle && (
        <SubValue
          value={subValue}
          isMissed={isDataLabel}
        >{`${subTitle}: ${subValue}%`}</SubValue>
      )}
      {isDataLabel && (
        <DataCollectedLabel>
          {t('reviewsPage.dataCollectedLabel')}
        </DataCollectedLabel>
      )}
    </Container>
  )
}
